import { render } from "./GiftReward.vue?vue&type=template&id=0582f715&scoped=true&ts=true"
import script from "./GiftReward.vue?vue&type=script&lang=ts"
export * from "./GiftReward.vue?vue&type=script&lang=ts"

import "./GiftReward.vue?vue&type=style&index=0&id=0582f715&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0582f715"]])

export default __exports__